const applyConfig = (config) => {
  config.blocks.requiredBlocks = [];

  return config;
};

export default applyConfig;
